import { Injectable } from '@angular/core';
import { Geolocation } from '@ionic-native/geolocation';
import { Http,Response } from '@angular/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

declare var google;

@Injectable()
export class GoogleMaps {
  //private api: string = "https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyDkuSWWkqabS4c1DOjSCTzw8Lsb_fT5FwU&latlng=42.11680767263054,%20-0.44092796879397156"
  private api: string = "https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyDkuSWWkqabS4c1DOjSCTzw8Lsb_fT5FwU&"
 
  mapElement: any;
  map: any;
  marker: any;
  apiKey: string = "AIzaSyDkuSWWkqabS4c1DOjSCTzw8Lsb_fT5FwU";
  centerChangedCallback: any;

  constructor(public http: Http,public geolocation: Geolocation) {
  }

  init(mapElement: any, centerChangedCallback: any,latitud,longitud): Promise<any> {
   
    this.mapElement = mapElement;
    this.centerChangedCallback = centerChangedCallback;

    return this.loadMap(latitud,longitud);
  }

  loadMap(latitud,longitud): Promise<any> {
  
    return new Promise((resolve) => {
   
      if (typeof google == 'undefined' || typeof google.maps == "undefined") {
        window['mapInit'] = () => {
          this.initMap(latitud,longitud).then(() => {
            resolve(true);
          });
        }

        let script = document.createElement("script");
        script.id = "googleMaps";

        if (this.apiKey) {
          script.src = 'https://maps.google.com/maps/api/js?key=' + this.apiKey + '&callback=mapInit';
        } else {
          script.src = 'https://maps.google.com/maps/api/js?callback=mapInit';
        }
 
        document.body.appendChild(script);
      } else {
           this.initMap(latitud,longitud).then(() => {
            resolve(true);
          });
         
          let script = document.createElement("script");
          script.id = "googleMaps2";
          document.body.appendChild(script);

      }
    });
  }

  initMap(latitud,longitud): Promise<any> {
   
    return new Promise((resolve) => {
      this.geolocation.getCurrentPosition().then((position) => {
   //     let center = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
   if(latitud){
   
   }else{
    latitud=position.coords.latitude;
    longitud=position.coords.longitude;
   }
   let center = new google.maps.LatLng(latitud,longitud );
        let mapOptions = {
          center: center,
          zoom: 17,
          mapTypeId: google.maps.MapTypeId.ROADMAP
        }

        this.map = new google.maps.Map(this.mapElement, mapOptions);
        var mylatLng = new google.maps.LatLng(latitud,longitud );
        this.marker = new google.maps.Marker({
          map: this.map,
          position:mylatLng
        });
        this.map.panTo(mylatLng);

        this.marker.setPosition(mylatLng);
        this.centerChangedCallback(mylatLng);


        this.map.addListener('click', e => {
          this.map.panTo(e.latLng);

          if (this.marker == undefined) {
           
          /*  this.marker = new google.maps.Marker({
              map: this.map,
              position: e.latLng
            });*/
          } else {
           
         
            this.marker.setPosition(e.latLng);
          }

          if (this.centerChangedCallback)
            this.centerChangedCallback(e.latLng);
        });

        resolve(true);
      });
    });
  }
  public capta_direccion(latitud,longitud): Observable<any> {
    return this.http.get(this.api+'latlng='+latitud+'%20'+longitud).map(this.extractData).catch(this.handleError);
  }
  public capta_coordenadas(direccion): Observable<any> {
    return this.http.get(this.api+'address='+direccion).map(this.extractData).catch(this.handleError);
  }
  private extractData(res: Response) {
    let body = res.json();
    return body || { };
  }

  private handleError (error: Response | any) {
    // In a real world app, you might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }
}


// WEBPACK FOOTER //
// ./src/providers/google-maps/google-maps.ts